// @flow
import React, { Component } from "react";
import { findDOMNode } from "react-dom";
import { withRouter, Link, browserHistory } from "react-router";

import Typography from "@material-ui/core/Typography";
import Popover from "@material-ui/core/Popover";
import { ColorSchema } from "../../global/types/scss";

type DisplayPopoverStatesType = {
  open: boolean,
  anchorEl: HTMLElement | null
};

class DisplayPopover extends Component<*, DisplayPopoverStatesType> {
  handleLink: Function;
  constructor() {
    super();
    this.state = {
      open: false,
      anchorEl: null
    };
    this.handleLink = this.handleLink.bind(this);
  }

  handleClickButton = () => {
    this.setState({
      open: true,
      anchorEl: findDOMNode(this.button)
    });
  };

  handleClose = () => {
    this.setState({
      open: false
    });
  };

  handleLink = () => {
    browserHistory.push("/" + this.props.params.conference + "/forgot");
    if(this.props.handleRequestClose){
      this.props.handleRequestClose();
    }
  }

  render(): React$Element<*> {
    const button = null;
    const { open, anchorEl } = this.state;
    return (
      <span>
        <span className="form-link" ref={node => { this.button = node; }} onClick={this.handleClickButton} onMouseOver={this.handleClickButton}>
          See More
        </span>
        <Popover
          open={open}
          anchorEl={anchorEl}
          anchorReference="anchorEl"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          anchorPosition={{
            top: 200,
            left: 400
          }}
          classes={{paper: "mui-form"}}
          onClose={this.handleClose}
        >
          <Typography variant="subheading" style={{ width: "90%", maxWidth: "400px", margin: "3% 5%" }}>
            If you have lost your access link you can click the <span onClick={this.handleLink} className="form-link-green" style={{ color: ColorSchema("primary") }}>Update your profile and Photo</span> link to request another one.<br />
          </Typography>
        </Popover>
      </span>
    );
  }
}

export default withRouter(DisplayPopover);


// WEBPACK FOOTER //
// ./src/conference/component/DisplayPopover.js